import React, { useEffect } from "react";
import "./logreportstyle.scss";
import { styled } from '@mui/material/styles';
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {  GetUserLogReportNew ,GetUserLogReportByFilterNew} from "../../services/api";
import dayjs from 'dayjs';
import useLogReportStyles from "./styles";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#DFF3FD',
    color: '#000',
    minWidth: '100px'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,

  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#D9D9D9',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function createData(transactionid, user, time, description) {
  return { transactionid, user, time, description };
}

const rows = [
  createData('DELR12563', 'Admin', '15-03-2023   11:00am', 'Updated Chemfab Alkali 2  -  Added new Inverter, ID: SDF12SDF56S4DF2SD1FD5S',),
  createData('DELR12563', 'Admin', '15-03-2023   11:00am', 'Updated Chemfab Alkali 2  -  Added new Inverter, ID: SDF12SDF56S4DF2SD1FD5S',),
];

const LogReport = ({ token }) => {
  const classes = useLogReportStyles();
  const [reportList, setReportList] = React.useState([]);
  const [FromDate, setFromDate] = React.useState(dayjs(new Date()).subtract(1, 'month'));
  const [ToDate, setToDate] = React.useState(dayjs(new Date()));

  useEffect(() => {
    GetUserLogReportNew(token).then((resp) => {
      if (resp?.data) {
        setReportList(resp?.data?.data)
      }
    })

  }, []);

  useEffect(() => {
    const FormatedFromdate = dayjs(FromDate).format('YYYY-MM-DD')
    const FormatedToDate = dayjs(ToDate).format('YYYY-MM-DD')
    GetUserLogReportByFilterNew(token, FormatedFromdate, FormatedToDate).then((resp) => {
      if (resp?.data) {
        setReportList(resp?.data?.data)
      }
    })

  }, [FromDate, ToDate, token]);

  return (
    <div className={classes.root}>
      <div className="bg_1">
        <div className="align_btw mb_10">
          <h5>Log Report</h5>

          <div>
            <div className="align_end">

              <div className="mr_8" >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <div>
                      <DatePicker
                        value={FromDate}
                        label="From Date"
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        onChange={(value) => setFromDate(value)}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <div className="mr_8" >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <div>
                      <DatePicker
                        value={ToDate}
                        label="To Date"
                        className={classes.datePicker}
                        format="DD-MM-YYYY"
                        onChange={(value) => setToDate(value)}
                        maxDate={dayjs()}
                      />
                    </div>
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              <button className="btn_style_search">Search</button>


            </div>
          </div>
        </div>
        <hr />

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Transaction ID</StyledTableCell>
                <StyledTableCell>Time</StyledTableCell>
                <StyledTableCell>Plant</StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reportList?.map((row) => (
                <StyledTableRow key={row.logId}>
                  <StyledTableCell component="th" scope="row">
                    {row?.logId}
                  </StyledTableCell>
                  <StyledTableCell>{dayjs(row?.timestamp).format('DD-MM-YY h:mm A')}</StyledTableCell>
                  <StyledTableCell>{row?.plantName}</StyledTableCell>
                  <StyledTableCell>{row?.details}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

LogReport.propTypes = {};

export default LogReport;
